<template>
  <div class="login-page">
    <!--顶部 Logo-->
    <div class="login-header" @click="toHome">
      <img class="logo-img" src="../../assets/lyjy_color.png" alt="">
      <div class="logo-text">
        <div class="logo-name">精准教研</div>
        <div class="logo-slogan">赋能教师专业化成长</div>
      </div>
    </div>

    <!--登录卡片-->
    <div class="login-card">
      <div class="login-form-wrap">
        <p class="login-type">账号密码登录</p>
        <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" size="large">
          <el-form-item prop="username">
            <el-input type="text" v-model="loginForm.username" placeholder="请输入登录手机号"
              prefix-icon="Iphone"></el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input type="password" show-password v-model="loginForm.password" placeholder="请输入密码"
              prefix-icon="Lock"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="loginBtn" type="primary" :loading="loginBtnLoading" @click="subUserLogin">登录</el-button>
          </el-form-item>
        </el-form>
        <div class="other-tab">
          <a @click="toCodeLogin">验证码登录</a>
          <a @click="toRes">注册</a>
          <a @click="toResetPwd">重置密码</a>
        </div>
      </div>
      <!--底部版权-->
      <div class="login-footer">
        版权所有©精准教研 | <a target="_blank" href="https://beian.miit.gov.cn">京ICP备2024046812号-6</a>
      </div>
    </div>

    <!--右侧人物-->
    <img class="login-people" src="../../assets/screen/people.png" alt="">
  </div>
</template>

<script>
import { userLogin, isAuthGroup } from "@/api/user/login";
let validateUsername = (rule, value, callback) => {
  isAuthGroup(value).then(res => {
    const result = res.data.data
    if (!result) {
      callback(new Error("该账号暂无权限登录"))
    } else {
      callback()
    }
  })
}
export default ({
  name: "userLogin",
  data() {
    return {
      loginBtnLoading: false,
        callback:'',
      /*登录数据绑定对象*/
      loginForm: {
        username: "",
        password: "",
          device:"website",
      },
      /*登录校验规则*/
      loginRules: {
        username: [
          { required: true, message: "请输入登录账号", trigger: "blur" },
          // { validator: validateUsername, trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      }
    }
  },
  created() {
    clearInterval(this.$store.state.zdy.isSetInter1)
    clearInterval(this.$store.state.zdy.isSetInter2)

    this.$store.dispatch('tagsView/delAllViews')
    this.$store.dispatch('tagsView/addView', {
      path: '/indexs',
      name: '首页',
      fullPath: '/indexs',
      title: '首页',
      meta: { title: '首页' },
    })
    let that = this
    document.onkeydown = function (e) {
      e = window.event || e;
      if (e.code === "Enter" || e.code === "enter") {
        that.subUserLogin();
      }
    }
  },
    mounted() {
        this.callback = this.$route.query.callback;
    },
  methods: {
    subUserLogin() {
      this.$refs.loginFormRef.validate(valid => {
        if (!valid) return
        let loginInfo = { username: this.loginForm.username, password: this.loginForm.password, device:"website" }
        this.loginBtnLoading = true
        userLogin(loginInfo).then(res => {
          if (res.data.code === 1) {
            const info = res.data.data
            this.$storage.set("userInfo", JSON.stringify(info.userInfo));
            this.$storage.set("token", info.token);
            this.$storage.set("role", info.role+'');
              this.$storage.set("isAnalyse",info.isAnalyse+'');
            this.$storage.set("isLogin", true);
            this.loginBtnLoading = false
              if (!this.callback){
                  this.$router.push("/jzedu/wel")
              }else {
                  window.open(this.callback,'_self')
              }

          } else {
            this.loginBtnLoading = false
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    toRes() {
      this.$router.push("/register")
    },
    toCodeLogin() {
        if (!this.callback){
            this.$router.push("/codeLogin")
        }else {
            this.$router.push({
                path: '/codeLogin',
                query: {
                    callback: this.callback,
                }
            });
        }

    },
    toResetPwd() {
      this.$router.push("/resetPwd")
    },
    toHome() {
      this.$router.push("/indexs")
    },
  }
})
</script >
<!--样式-->
<style lang="scss" scoped>
.login-page {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: url("../../assets/screen/loginBg.png") no-repeat center center;
  background-size: cover;
}

/*顶部 Logo*/
.login-header {
  position: absolute;
  top: 24px;
  left: 48px;
  display: flex;
  align-items: center;
  z-index: 3;
  cursor: pointer;

  .logo-img {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    margin-right: 12px;
  }

  .logo-name {
    font-size: 26px;
    font-weight: 700;
    color: #ff7f2e;
    line-height: 1.2;
  }

  .logo-slogan {
    font-size: 13px;
    color: #d0942f;
    margin-top: 4px;
  }
}

/*登录卡片*/
.login-card {
  position: absolute;
  left: 6.5%;
  top: 52%;
  transform: translateY(-50%);
  width: 600px;
  background: #ffffff;
  border-radius: 24px;
  padding-top: 44px;
  z-index: 2;
}

.login-form-wrap {
  width: 420px;
  margin: 0 auto;
}

.login-type {
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  color: #ff7f2e;
  margin: 0 0 28px;
}

/deep/ .el-input__wrapper {
  height: 46px;
  background: #eef3f9;
  border-radius: 8px;
  box-shadow: 0 0 0 1px #d8e2ef inset;
}

/deep/ .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px #ff7f2e inset;
}

/deep/ .el-form-item {
  margin-bottom: 22px;
}

.loginBtn {
  width: 100%;
  height: 46px;
  font-size: 16px;
  border-radius: 8px;
  background: #ff7f2e;
  border-color: #ff7f2e;
}

.other-tab {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;

  a {
    cursor: pointer;
    font-size: 14px;
    color: #ff7f2e;
  }

  a:hover {
    color: #ff7f2e;
  }
}

/*底部版权*/
.login-footer {
  padding: 44px 0 28px;
  text-align: center;
  font-size: 14px;
  color: #4c596e;

  a {
    text-decoration: none;
    color: #ff7f2e;
  }
}

/*右侧人物*/
.login-people {
  position: absolute;
  right: 7%;
  bottom: 0;
  height: 80%;
  z-index: 1;
}

@media screen and (max-width: 1100px) {
  .login-people {
    display: none;
  }
}
</style>
